<template>
  <div class="site-cell-container" :class="{ active }">
    <a-tooltip placement="top">
      <template slot="title">
        <span>{{name}}</span>
      </template>
      <div class="name">{{ name }}</div>
    </a-tooltip>

    <a-icon type="star" theme="filled" class="star filled" v-if="active" />
    <a-icon type="star" class="star" v-else />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.site-cell-container {
  width: 100%;
  height: 48px;
  background: #fafafa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: #333333;
  justify-content: space-around;
  padding: 0 10px;
  cursor: pointer;
  overflow: hidden;

  &.active {
    border: 1px solid #ffdb5d;
  }

  .name {
    width:80%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .star {
    font-size: 18px;
    flex-shrink: 0;

    &.filled {
      color: #ffdb5d;
    }
  }
}
</style>
